import { useCallback } from 'react';
import { get, isNil, isPlainObject, set } from 'lodash';
import { ILayoutComponent } from '@diana/core';

export const useGetComponentDefaultPropertiesBySchema = () => {
  return useCallback((componentSchema: any): ILayoutComponent['properties'] => {
    const defaultProperties = {} as ILayoutComponent['properties'];

    if (!isPlainObject(componentSchema)) {
      return defaultProperties;
    }

    const definitions = isPlainObject(componentSchema.definitions)
      ? componentSchema.definitions
      : {};
    const resolveSchema = (schema: any) => {
      const ref = schema.$ref;
      if (ref && ref.startsWith('#/definitions/')) {
        const definition = definitions[ref.replace('#/definitions/', '')];
        if (isPlainObject(definition)) return definition;
      }
      return schema;
    };

    const propertiesType = get(componentSchema, 'properties.properties', null);
    if (!isPlainObject(propertiesType)) {
      return defaultProperties;
    }

    const types: any[] = [propertiesType];
    if (Array.isArray(propertiesType.oneOf)) {
      types.push(...propertiesType.oneOf);
    }
    if (Array.isArray(propertiesType.anyOf)) {
      types.push(...propertiesType.anyOf);
    }

    const resolvedType = types
      .filter(isPlainObject)
      .map(resolveSchema)
      .find((s) => s.type === 'object');

    if (isPlainObject(resolvedType) && isPlainObject(resolvedType.properties)) {
      for (const [key, schema] of Object.entries<any>(resolvedType.properties)) {
        if (isPlainObject(schema) && !isNil(schema.default)) {
          set(defaultProperties, key, schema.default);
        }
      }
    }

    return defaultProperties;
  }, []);
};
